import { Component, OnInit, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'eyrus-banner-alert',
  templateUrl: './banner-alert.component.html',
  styleUrls: ['./banner-alert.component.sass']
})
export class BannerAlertComponent implements OnInit {

  @Input() title: String = '';
  @Input() type: String = 'default';

  @Output() closed: Subject<any> = new Subject<any>();

  display: Boolean = true;

  constructor() { }

  ngOnInit() {
  }

  close() {
    this.display = false;
    this.closed.next();
  }

}
